import * as React from 'react';

function SvgTick(props) {
  return (
    <svg width={12} height={9} viewBox="0 0 12 9" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5303 0.46967C11.8232 0.762563 11.8232 1.23744 11.5303 1.53033L4.53033 8.53033C4.23744 8.82322 3.76256 8.82322 3.46967 8.53033L0.46967 5.53033C0.176777 5.23744 0.176777 4.76256 0.46967 4.46967C0.762563 4.17678 1.23744 4.17678 1.53033 4.46967L4 6.93934L10.4697 0.46967C10.7626 0.176777 11.2374 0.176777 11.5303 0.46967Z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgTick;
